import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function Repair({ color = 'icon.primary', fill = 'transparent', ...props }) {
  return (
    <IconBase viewBox='0 0 24 24' {...props}>
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.2779 10.5419L14.2519 7.56792C14.2706 7.5491 14.279 7.52228 14.2742
         7.49614C14.2694 7.47 14.2521 7.44787 14.2279 7.43692C12.4726 6.68233
          10.4352 7.06537 9.07388 8.40592C7.7695 9.68097 7.35023 11.6106 8.00788
           13.3119L3.55188 17.7709C2.81604 18.5077 2.81604 19.7012 3.55188 20.4379C4.28861
            21.1738 5.48215 21.1738 6.21888 20.4379L10.7109 15.9459C12.461 16.5972 14.431
             16.1383 15.7132 14.7806C16.9954 13.423 17.341 11.43 16.5909 9.71992C16.5793
              9.69658 16.5573 9.68012 16.5317 9.67558C16.506 9.67104 16.4798 9.67897 16.4609
               9.69692L13.4119 12.6749L12.3459 11.6059L11.2779 10.5419Z'
        stroke={color}
        fill={fill}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M7.1055 19.5443C10.9748 22.0587 16.1179 21.2474 19.0252 17.6638C21.9325 14.0803
         21.6662 8.88034 18.4081 5.61247C15.1501 2.3446 9.95097 2.06275 6.35871 4.95927C2.76646
          7.85578 1.93965 12.9964 4.4425 16.8733'
        stroke={color}
        fill={fill}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </IconBase>
  )
}

Repair.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
}

export default Repair
